<template>
  <div v-if="enableRecaptcha">
    <v-form>
      <v-row
        align="center"
        justify="center"
      >
        <v-card
          min-width="90%"
          :class="gR.class"
          :outlined="true"
        >
          <v-card-text>
            <v-row>
              <v-col
                cols="3"
              >
                <v-expand-transition>
                  <div
                    v-show="gR.init.btnVisible"
                  >
                    <v-btn
                      fab
                      elevation="0"
                      :class="gR.class"
                      @click="onSubmit"
                    >
                      <v-icon>
                        mdi-checkbox-blank-outline
                      </v-icon>
                    </v-btn>
                  </div>
                </v-expand-transition>
                <v-expand-transition>
                  <div
                    v-show="gR.ok.btnVisible"
                  >
                    <v-btn
                      fab
                      elevation="0"
                      :class="gR.class"
                      @click="resetRecaptcha"
                    >
                      <v-icon>
                        mdi-account-check-outline
                      </v-icon>
                    </v-btn>
                  </div>
                </v-expand-transition>
                <v-expand-transition>
                  <div
                    v-show="gR.error.btnVisible"
                  >
                    <v-btn
                      fab
                      elevation="0"
                      :class="gR.class"
                      @click="resetRecaptcha"
                    >
                      <v-icon>
                        mdi-alert
                      </v-icon>
                    </v-btn>
                  </div>
                </v-expand-transition>
                <v-expand-transition>
                  <div
                    v-show="gR.progress.btnVisible"
                  >
                    <v-btn
                      fab
                      elevation="0"
                      :class="gR.class"
                      :loading="gR.progress.btnVisible"
                    />
                  </div>
                </v-expand-transition>
              </v-col>
              <v-col
                cols="9"
                align-self="center"
              >
                <v-expand-transition>
                  <v-sheet
                    :class="gR.class"
                    v-show="gR.init.msgVisible"
                  >
                    Por favor, confirme que você é um eleitor.
                  </v-sheet>
                </v-expand-transition>
                <v-expand-transition>
                  <v-sheet
                    :class="gR.class"
                    v-show="gR.ok.msgVisible"
                  >
                    Verificação concluída com sucesso!
                  </v-sheet>
                </v-expand-transition>
                <v-expand-transition>
                  <v-sheet
                    :class="gR.class"
                    v-show="gR.error.msgVisible"
                  >
                    Atenção! Não foi possível validar o eleitor.
                  </v-sheet>
                </v-expand-transition>
                <v-expand-transition>
                  <v-sheet
                    :class="gR.class"
                    v-show="gR.exError.msgVisible"
                  >
                    Validação Necessária: Por favor, confirme que você é um eleitor.
                  </v-sheet>
                </v-expand-transition>
                <v-expand-transition>
                  <v-sheet
                    :class="gR.class"
                    v-show="gR.progress.msgVisible"
                  >
                    Validando...
                  </v-sheet>
                </v-expand-transition>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'ValidateRecaptcha',
  data: () => ({
    enableRecaptcha: false,
    sitekey: '',
    recaptchaVerified: false,
    recaptcha: '',
    gR: {
      class: 'recaptchaOnline',
      init: {
        btnVisible: true,
        msgVisible: true,
        class: 'recaptchaOnline'
      },
      ok: {
        btnVisible: false,
        msgVisible: false,
        class: 'recaptchaOnlineSucess'
      },
      error: {
        btnVisible: false,
        msgVisible: false,
        class: 'recaptchaOnlineError'
      },
      exError: {
        msgVisible: false
      },
      progress: {
        btnVisible: false,
        msgVisible: false
      }
    }
  }),
  async beforeMount() {
    this.sitekey = process.env.VUE_APP_RECAPTCHA_KEY;
    const googleScript = `https://www.google.com/recaptcha/enterprise.js?render=${this.sitekey}`;
    const tag = document.head.querySelector(`script[src="${googleScript}"]`);
    if (!tag) {
      const recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', googleScript);
      recaptchaScript.setAttribute('async', true);
      recaptchaScript.setAttribute('defer', true);
      document.head.appendChild(recaptchaScript);
    }
  },
  methods: {
    load(internalEnableRecaptcha) {
      this.enableRecaptcha = internalEnableRecaptcha;
      this.clearRecaptcha();
    },
    async onSubmit() {
      this.grProgressExec();
      try {
        window.grecaptcha.enterprise.ready(async () => {
          try {
            const token = await window.grecaptcha.enterprise.execute(this.sitekey, { action: 'LOGIN' });
            this.callbackRecaptcha(token);
          } catch (error) {
            this.grErrorExec();
          }
        });
      } catch (error) {
        this.grErrorExec();
      }
    },
    async callbackRecaptcha(token) {
      this.recaptcha = token;
      this.recaptchaVerified = true;
      if (this.recaptcha) {
        this.grOkExec();
      }
    },
    resetRecaptcha() {
      if (this.enableRecaptcha) {
        this.clearRecaptcha();
      }
    },
    clearRecaptcha() {
      this.recaptcha = '';
      this.recaptchaVerified = false;
      this.grInitExec();
    },
    async verifyRecaptcha() {
      let outResult = true;
      if (this.enableRecaptcha) {
        await this.grProgressExec();
        if (!this.recaptchaVerified) {
          await this.grExErrorExec();
          outResult = false;
        } else {
          await this.grOkExec();
        }
      }
      return outResult;
    },
    getRecaptcha() {
      let outJson = null;
      if (this.enableRecaptcha) {
        outJson = {};
        outJson.recaptcha = this.recaptcha;
      }
      return outJson;
    },
    async grClear() {
      this.gR.init.btnVisible = false;
      this.gR.init.msgVisible = false;
      this.gR.ok.btnVisible = false;
      this.gR.ok.msgVisible = false;
      this.gR.error.btnVisible = false;
      this.gR.error.msgVisible = false;
      this.gR.progress.btnVisible = false;
      this.gR.progress.msgVisible = false;
      this.gR.exError.msgVisible = false;
      this.gR.class = '';
    },
    async grInitExec() {
      await this.grClear();
      this.gR.init.btnVisible = true;
      this.gR.init.msgVisible = true;
      this.gR.class = this.gR.init.class;
    },
    async grProgressExec() {
      await this.grClear();
      this.gR.progress.msgVisible = true;
      this.gR.progress.btnVisible = true;
      this.gR.class = this.gR.init.class;
    },
    async grOkExec() {
      await this.grClear();
      this.gR.ok.btnVisible = true;
      this.gR.ok.msgVisible = true;
      this.gR.class = this.gR.ok.class;
    },
    async grErrorExec() {
      await this.grClear();
      this.gR.error.btnVisible = true;
      this.gR.error.msgVisible = true;
      this.gR.class = this.gR.error.class;
    },
    async grExErrorExec() {
      await this.grClear();
      this.gR.init.btnVisible = true;
      this.gR.exError.msgVisible = true;
      this.gR.class = this.gR.error.class;
    }

  }
};
</script>

<style lang="scss">
  div .v-card .recaptchaOnline{
    background-color: white !important;
    border-color: indigo !important;
  }
  div .v-sheet .recaptchaOnline{
    color: indigo !important;
  }
  button .v-btn .recaptchaOnline{
    background-color: indigo !important;
    color: white !important;
  }

  div .v-card .recaptchaOnlineSucess{
    background-color: white !important;
    border-color: #1B5E20 !important;
  }
  div .v-sheet .recaptchaOnlineSucess{
    color: #1B5E20 !important;
  }
  button .v-btn .recaptchaOnlineSucess{
    background-color: white !important;
    color: #1B5E20 !important;
  }

  div .v-card .recaptchaOnlineError{
    background-color: white !important;
    border-color: #FF5252 !important;
  }
  div .v-sheet .recaptchaOnlineError{
    color: #FF5252 !important;
  }
  button .v-btn .recaptchaOnlineError{
    background-color: white !important;
    color: #FF5252 !important;
  }
  .v-btn--icon.v-size--default .v-icon, .v-btn--fab.v-size--default .v-icon {
    font-size: 40px !important;
  }
</style>
